export const GET = Object.freeze({
  REQUEST: 'dailyCheckProcedure/GET_REQUEST',
  SUCCESS: 'dailyCheckProcedure/GET_SUCCESS',
  ERROR: 'dailyCheckProcedure/GET_ERROR',
});

export const GET_BY_PROJECT_ID = Object.freeze({
  REQUEST: 'dailyCheckProcedure/GET_BY_PROJECT_ID_REQUEST',
  SUCCESS: 'dailyCheckProcedure/GET_BY_PROJECT_ID_SUCCESS',
  ERROR: 'dailyCheckProcedure/GET_BY_PROJECT_ID_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'dailyCheckProcedure/FIND_REQUEST',
  SUCCESS: 'dailyCheckProcedure/FIND_SUCCESS',
  ERROR: 'dailyCheckProcedure/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'dailyCheckProcedure/CREATE_REQUEST',
  SUCCESS: 'dailyCheckProcedure/CREATE_SUCCESS',
  ERROR: 'dailyCheckProcedure/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'dailyCheckProcedure/UPDATE_REQUEST',
  SUCCESS: 'dailyCheckProcedure/UPDATE_SUCCESS',
  ERROR: 'dailyCheckProcedure/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'dailyCheckProcedure/DELETE_REQUEST',
  SUCCESS: 'dailyCheckProcedure/DELETE_SUCCESS',
  ERROR: 'dailyCheckProcedure/DELETE_ERROR',
});

export const RESET_STATE = 'dailyCheckProcedure/RESET_STATE';

export const GET_PROCEDURES_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const GET_PROCEDURES_BY_PROJECT_ID_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET_BY_PROJECT_ID.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET_BY_PROJECT_ID.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET_BY_PROJECT_ID.ERROR,
    payload,
    error: true,
  }),
});

export const FIND_PROCEDURE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_PROCEDURE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_PROCEDURE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_PROCEDURE_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});
